import { mapState } from "vuex";

export default {
  data: () => ({}),
  computed: mapState({
    isAuth: (state) => state.global.isAuth,
  }),
  methods: {},
};
